import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

export const CrmReadinessBadge = ({ dark = false }) => {
  const [data, setData] = useState(null);
  const [provider, setProvider] = useState("");
  useEffect(() => {
    api.get(`/public/crm-readiness${provider ? `?provider=${provider}` : ""}`).then(({ data }) => setData(data)).catch(() => {});
  }, [provider]);
  if (!data) return null;
  const box = dark ? "bg-[#0E1624] border-[#1E2C45] text-slate-300" : "bg-indigo-50/60 border-indigo-100 text-slate-600";
  return (
    <div className={`rounded-2xl border p-4 ${box}`} data-testid="crm-readiness-badge">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`flex items-center gap-1.5 text-xs font-bold ${dark ? "text-blue-300" : "text-indigo-700"}`}>
          <Sparkles className="w-4 h-4" /> CRM Readiness Score
        </span>
        <select value={provider} onChange={(e) => setProvider(e.target.value)} data-testid="crm-readiness-select"
          className={`ml-auto rounded-full px-2.5 py-1 text-[11px] border ${dark ? "bg-[#152033] border-[#1E2C45] text-slate-300" : "bg-white border-slate-200 text-slate-600"}`}>
          <option value="">Which CRM does your firm use?</option>
          {(data.supported_crms || []).map((c) => <option key={c.key} value={c.key}>{c.name}</option>)}
        </select>
      </div>
      <div className="mt-2 flex items-center gap-3">
        <span className={`text-3xl font-extrabold font-heading ${dark ? "text-white" : "text-navy"}`} data-testid="crm-readiness-score">+{data.score}</span>
        <p className="text-[11px] leading-snug">{data.message}</p>
      </div>
      <div className="mt-2 flex flex-wrap gap-1">
        {(data.added_capabilities || []).map((c) => (
          <span key={c} className={`px-2 py-0.5 rounded-full text-[9px] font-semibold ${dark ? "bg-[#152033] text-slate-400" : "bg-white text-slate-500 border border-slate-100"}`}>✓ {c}</span>
        ))}
      </div>
      {data.integration && (
        <p className={`mt-2 text-[10px] ${dark ? "text-slate-500" : "text-slate-400"}`} data-testid="crm-readiness-integration">
          {data.display_name}: syncs {data.integration.sections_synced.join(", ")} · {data.integration.mode}
        </p>
      )}
    </div>
  );
};

export default CrmReadinessBadge;
